var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{staticClass:"text-center",attrs:{"id":"loaderWrap"}},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"primary","label":"Large Spinner"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }